import { useLocale } from "@/modules/navigation"
import { classNames } from "@punks/ui-core"

export type LanguageButtonProps = {
  className?: string
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  expanded?: boolean
}

export const LanguageButton: React.FC<LanguageButtonProps> = ({
  className,
  onClick,
  expanded,
}) => {
  const { locale } = useLocale()
  return (
    <button
      type="button"
      className={classNames(
        "uppercase font-medium flex gap-1 items-center",
        className
      )}
      onClick={onClick}
      aria-label="language picker"
    >
      <span className="inline-flex items-center justify-center rounded-full aspect-square w-8">
        {locale}
      </span>
      <svg
        className={classNames("transition-transform duration-500", {
          "rotate-180": expanded,
        })}
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 1L5 5L1 1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  )
}
